import React from 'react'
import Navbar from './Navbar'

const Awards = () => {
    return (
        <section className="resume-section" id="awards">
            <Navbar/>
            <div className="resume-section-content">
                <h2 className="mb-5">Awards</h2>
                <ul className="fa-ul mb-0">
                    <li>
                        <span className="fa-li"><i className="fas fa-trophy text-warning"></i></span>
                        Microsoft Student Partner
                    </li>
                    <li>
                        <span className="fa-li"><i className="fas fa-trophy text-warning"></i></span>
                        Windows Ucrew Evengalist
                    </li>
                </ul>
            </div>
        </section>
    )
}

export default Awards
